import requests from './index';
import properties from './properties';

const { _API_PREFIX_CONTACT } = properties;

/**
 *
 * @param {*} page
 * @param {*} size
 * @param {*} pubType
 * @returns {*}
 */
export const getGroupList = (page, size, pubType, originUser, cUserId) => {
  const url = `${_API_PREFIX_CONTACT}/group?page=${page}&size=${size}&pubType=${pubType}&srchField=groupNames&srchValue=&orderField=groupName&orderType=ASC&originUser=${originUser}&cUserId=${cUserId}`;
  return requests.get(url);
};

/**
 *
 * @param {*} page
 * @param {*} size
 * @param {*} pubType
 * @returns {*}
 */
export const getContactList = (page, size, pubType, originUser, cUserId, orderType, orderField) => {
  const url = `${_API_PREFIX_CONTACT}/cards?page=${page}&size=${size}&pubType=${pubType}&orderField=${
    orderField ?? 'memberName'
  }&orderType=${orderType}&addInfo=all&originUser=${originUser}&cUserId=${cUserId}`;
  return requests.get(url);
};

/**
 *
 * @param {*} groupID
 * @param {*} page
 * @param {*} size
 * @param {*} pubType
 * @returns {*}
 */
export const getMemberGroup = (groupID, page, size, pubType, originUser, cUserId, orderType, orderField) => {
  const url = `${_API_PREFIX_CONTACT}/group/${groupID}/members?page=${page}&size=${size}&pubType=${pubType}&orderField=${
    orderField ?? 'memberName'
  }&orderType=${orderType}&groupId=${groupID}&originUser=${originUser}&cUserId=${cUserId}`;
  return requests.get(url);
};

/**
 *
 * @param {*} type
 * @param {*} keyword
 * @param {*} page
 * @param {*} size
 * @param {*} pubType
 * @returns
 */
export const searchContactCardAPI = (groupId, type, keyword, pageNumber, size, pubType, originUser, cUserId) => {
  const params = {
    groupId,
    page: pageNumber + 1,
    size,
    pubType,
    type,
    keyword,
    sort: 'FULLNAME',
    order: 'ASC',
    originUser,
    cUserId,
  };
  const url = `${_API_PREFIX_CONTACT}/cards/search`;
  return requests.get(url, params);
};

/**
 *
 * @param {*} type
 * @param {*} keyword
 * @param {*} page
 * @param {*} size
 * @param {*} pubType
 * @returns
 */
export const searchContactCardPublicAPI = (type, keyword, pageNumber, size, pubType, originUser, cUserId) => {
  const params = {
    page: pageNumber + 1,
    size,
    pubType,
    type,
    keyword,
    sort: 'FULLNAME',
    order: 'ASC',
    originUser,
    cUserId,
  };
  const url = `${_API_PREFIX_CONTACT}/cards/public/search`;
  return requests.get(url, params);
};

/**
 *
 * @param {*} type
 * @param {*} keyword
 * @param {*} page
 * @param {*} size
 * @param {*} pubType
 * @returns
 */
export const searchContactGroupAPI = (type, keyword, pageNumber, size, pubType, originUser, cUserId) => {
  const params = {
    page: pageNumber + 1,
    size,
    pubType,
    type,
    keyword,
    originUser,
    cUserId,
  };
  const url = `${_API_PREFIX_CONTACT}/group/public/search`;
  return requests.get(url, params);
};

/**
 *
 * @param {*} keyword
 * @returns
 */
export const searchGroupAPI = (keyword, originUser, cUserId) => {
  const params = {
    type: 'GROUPNAME',
    keyword,
    originUser,
    cUserId,
  };
  const url = `${_API_PREFIX_CONTACT}/group/search`;
  return requests.get(url, params);
};

/**
 *
 * @param {*} keyword
 * @returns
 */
export const searchAddressAPI = (keyword, page, size, isNoSession) => {
  const params = {
    page,
    size,
    keyword,
  };
  if (isNoSession) {
    params.noSessionPrc = 'Y';
  }
  const url = `${_API_PREFIX_CONTACT}/address/search`;
  return requests.get(url, params);
};

/**
 *
 * @param {*} page
 * @param {*} size
 * @returns
 */
export const getGroupsAPI = (page, size) => {
  const url = `${_API_PREFIX_CONTACT}/group?page=${page}&size=${size}`;
  return requests.get(url);
};

/**
 *
 * @param {*} subject
 * @returns
 */
export const createGroupAPI = subject => {
  const url = `${_API_PREFIX_CONTACT}/group/create`;
  const body = {
    subject,
  };
  return requests.post(url, body);
};

/**
 *
 * @param {*} data
 * @returns
 */
export const createContactAPI = (data, isEmployeeCopy = false) => {
  const url = `${_API_PREFIX_CONTACT}/cards/contacts/create${isEmployeeCopy ? '?isEmployeeCopy=YES' : ''}`;
  return requests.post(url, data);
};

/**
 *
 * @param {*} uidGroup
 * @returns
 */
export const getContactAPI = uid => {
  const url = `${_API_PREFIX_CONTACT}/group/${uid}`;
  return requests.get(url);
};

/**
 *
 * @param {*} uid
 * @param {*} body
 * @returns
 */
export const updateContactAPI = (uid, body) => {
  const url = `${_API_PREFIX_CONTACT}/group/${uid}/update?updateType=members`;
  return requests.post(url, body);
};

/**
 *
 * @returns
 */
export const getGroupTeamAPI = (userID, originUser, cUserId) => {
  const url = `${_API_PREFIX_CONTACT}/cards/teams/group?userId=${userID}&originUser=${originUser}&cUserId=${cUserId}`;
  return requests.get(url);
};

/**
 *
 * @returns
 */
export const getContactTeamAPI = (userID, groupID, page, size, originUser, cUserId) => {
  const url = `${_API_PREFIX_CONTACT}/cards/teams/contact?userId=${userID}&groupId=${groupID}&page=${page}&size=${size}&originUser=${originUser}&cUserId=${cUserId}`;
  return requests.get(url);
};

/**
 * @param {string} uid
 * @returns
 */
export const getContacInfor = (uid, groupID, originUser, cUserId) => {
  const url = `${_API_PREFIX_CONTACT}/cards/${uid}?groupId=${groupID}&originUser=${originUser}&cUserId=${cUserId}`;
  return requests.get(url);
};

export const createRecentContact = itemId => {
  const url = `/employee/empsearch/rest/v1/recent/create/contactgroup`;
  const body = {
    itemId,
  };
  return requests.post(url, body);
};

/**
 *
 * @returns
 */
export const fetchPubContactMenu = uid => {
  const url = `${_API_PREFIX_CONTACT}/admin/policy`;
  return requests.get(url);
};
